/* eslint-disable react/no-array-index-key */
/* eslint-disable no-empty */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import {
  cartAddItem,
  cartAddItemCache, cartRemoveItem, cartRemoveItemCache, cartUpdateItem,
} from '../../app/store/actions/cart';
import { favoritesRemoveItem, updateFavorite } from '../../app/store/actions/favorites';
import CartUtil from '../../app/utils/cart';
import ROUTES from '../../data/routes';
import validator from '../../helpers/validators';
import SimpleSpin from '../loading/SimpleSpin';
import PriceComponent from '../price/Price';
import HeaderCartItem from './HeaderCartItem';

const RctSwal = withReactContent(Swal);

class HeaderCartMenu extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      offHandlers: false,
    };
  }

  closeMenuAndPush = (route) => {
    this.props.closeCartMenu();

    const { punchOut, typeOfAccess, userEmail } = this.props;

    if (!!punchOut && typeOfAccess === 'normal') {
      RctSwal.fire({
        icon: 'error',
        titleText: I18n.t('attention'),
        html: `
          <div style="text-align: justify">
            <p style="margin: 20px 0px">${I18n.t('invalidPunchoutUserAccess1', { 0: userEmail || '' })}</p>
            <p>${I18n.t('invalidPunchoutUserAccess3')}</p>
          </ >
        `,
      });
    } else if ((punchOut === null || punchOut === undefined) && typeOfAccess === 'punchout') {
      RctSwal.fire({
        icon: 'error',
        titleText: I18n.t('attention'),
        html: `
          <div style="text-align: justify">
            <p style="margin: 20px 0px">${I18n.t('invalidPunchoutUserAccess2', { 0: userEmail || '' })}</p>
            <p>${I18n.t('invalidPunchoutUserAccess3')}</p>
          </ >
        `,
      });
    } else {
      setTimeout(() => this.props.history.push(route), 100);
    }
  }

  updateProductToCart = async (amount, xped, item, allowSellSpotItensWithoutStock) => {
    try {
      this.setState({ offHandlers: true });
      if (item.product) {
        if (validator.isSpotProductAmountInvalid(
          amount, item.product.stock, allowSellSpotItensWithoutStock, item.product.isSpot, item.product.price.isContract,
        )) return;
        await this.props.updateItem(item.product.id, item.product.clientCode, amount, xped, false);
      }
    } catch (e) { }

    this.setState({ offHandlers: false });
  }

  validationMaximumContractValue = () => {
    const valueContract = [];
    const contractId = [];

    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < this.props.cartItems.length; index++) {
      if (this.props.cartItems[index].product && this.props.cartItems[index].product.valueContract) {
        valueContract.push(this.props.cartItems[index].product.valueContract);
        contractId.push(this.props.cartItems[index].product.contractId);
      }
    }

    const valueContractErro = this.props.cartItems.findIndex(element => (
      element.product.erro === true || element.product.erro === 'true'));


    let contractLimitAction = this.props.cartItems.find(element => (element.product.contractLimitAction === 1));
    if (!contractLimitAction) contractLimitAction = this.props.cartItems.find(element => (element.product.contractLimitAction === 2));

    contractLimitAction = (contractLimitAction
      && contractLimitAction.product
      && contractLimitAction.product.contractLimitAction)
      ? contractLimitAction.product.contractLimitAction
      : '';

    return {
      contractLimitAction, valueContract, contractId, valueContractErro,
    };
  }

  renderButton = () => {
    const {
      cartItems, purchasePermission, isAuthenticated, minimumPrice, buttonLabel, taxesCart, punchOut, selectedContract,
      allowSellSpotItensWithoutStock, companyTag, openSideLogin, closeCartMenu,
    } = this.props;

    const {
      contractLimitAction, valueContract, contractId, valueContractErro,
    } = this.validationMaximumContractValue();

    if (!!punchOut && contractLimitAction !== 1 && valueContractErro < 0) {
      return (
        <div>
          <button
            className="btn-finish"
            type="button"
            onClick={() => this.closeMenuAndPush(ROUTES.CART)}
          >
            {I18n.t('buyPunchOut').toUpperCase()}
          </button>
          {contractLimitAction === 2 && (
            <p className="error-msg">
              {(contractId.length > 1)
                ? `${I18n.t('noticeMaximumValueContracts1')} ${contractId} ${I18n.t('noticeMaximumValueContracts2')} `
                : `${I18n.t('noticeMaximumContractValue1')} ${contractId} ${I18n.t('noticeMaximumContractValue2')} `
              }
              {valueContract.map(element => (
                <span>
                  {' '}
                  <PriceComponent value={element} />
                </span>
              ))}
              {(contractId.length > 1)
                ? ` ${I18n.t('noticeMaximumValueContracts3')}`
                : ` ${I18n.t('noticeMaximumContractValue3')}`
              }
            </p>
          )}
        </div>
      );
    }

    if (!!punchOut && (contractLimitAction === 1 || valueContractErro >= 0)) {
      return (
        <div>
          {(valueContractErro < 0)
            ? (
              <p className="error-msg">
                {(contractId.length > 1)
                  ? `${I18n.t('noticeMaximumValueContracts1')} ${contractId} ${I18n.t('noticeMaximumValueContracts2')} `
                  : `${I18n.t('noticeMaximumContractValue1')} ${contractId} ${I18n.t('noticeMaximumContractValue2')} `
                }
                {valueContract.map(element => (
                  <span>
                    {' '}
                    <PriceComponent value={element} />
                  </span>
                ))}
                {(contractId.length > 1)
                  ? ` ${I18n.t('noticeMaximumValueContracts3')}`
                  : ` ${I18n.t('noticeMaximumContractValue3')}`
                }
              </p>
            )
            : (
              <p className="error-msg">
                {I18n.t('erroMaximumContractValue')}
              </p>
            )
          }
        </div>
      );
    }

    const cartTotal = CartUtil.getCartTotal(cartItems, !taxesCart, undefined, undefined, companyTag);

    const hasItemWithoutStock = cartItems.filter(item => validator.isSpotProductAmountInvalid(
      item.total, item.product.stock, allowSellSpotItensWithoutStock, item.product.isSpot,
      item.product.price.isContract,
    ));

    if (!isAuthenticated) {
      return (
        <button
          className="btn-finish"
          type="button"
          onClick={() => {
            closeCartMenu();
            openSideLogin();
          }}
        >
          {I18n.t('finalizeBuy').toUpperCase()}
        </button>
      );
    }

    if (hasItemWithoutStock && hasItemWithoutStock.length > 0) {
      return (
        <p className="error-msg">
          {I18n.t('invalidItemsCart').toUpperCase()}
        </p>
      );
    }

    if (!punchOut && (
      (selectedContract && selectedContract.limit && cartTotal > Number(selectedContract.limit))
      || !purchasePermission
    )) {
      return (
        <button
          className="btn-finish"
          type="button"
          onClick={() => this.closeMenuAndPush(ROUTES.CART)}
        >
          {I18n.t('buySolicitation').toUpperCase()}
        </button>
      );
    }

    if (!punchOut
      && purchasePermission
      && minimumPrice <= CartUtil.getCartTotal(cartItems, !taxesCart, undefined, undefined, companyTag)
      && contractLimitAction !== 1
      && valueContractErro < 0
    ) {
      return (
        <div>
          <button
            className="btn-finish"
            type="button"
            onClick={() => this.closeMenuAndPush(ROUTES.CART)}
          >
            {buttonLabel ? buttonLabel.toUpperCase() : I18n.t('finalizeBuy').toUpperCase()}
          </button>
          {contractLimitAction === 2 && (
            <p className="error-msg">
              {(contractId.length > 1)
                ? `${I18n.t('noticeMaximumValueContracts1')} ${contractId} ${I18n.t('noticeMaximumValueContracts2')} `
                : `${I18n.t('noticeMaximumContractValue1')} ${contractId} ${I18n.t('noticeMaximumContractValue2')} `
              }
              {valueContract.map(element => (
                <span>
                  {' '}
                  <PriceComponent value={element} />
                </span>
              ))}
              {(contractId.length > 1)
                ? ` ${I18n.t('noticeMaximumValueContracts3')}`
                : ` ${I18n.t('noticeMaximumContractValue3')}`
              }
            </p>
          )}
        </div>
      );
    }

    if (!punchOut && purchasePermission && minimumPrice > cartTotal && valueContractErro < 0) {
      return (
        <div>
          <p className="error-msg" style={{ fontWeight: 600 }}>
            {I18n.t('minimumPayment')}
            {' '}
            {minimumPrice}
            {' '}
            {I18n.t('minimumPayment2')}
          </p>
        </div>
      );
    }

    if (!punchOut && purchasePermission && (contractLimitAction === 1 || valueContractErro >= 0)) {
      return (
        <div>
          {(valueContractErro < 0)
            ? (
              <p className="error-msg">
                {(contractId.length > 1)
                  ? `${I18n.t('noticeMaximumValueContracts1')} ${contractId} ${I18n.t('noticeMaximumValueContracts2')} `
                  : `${I18n.t('noticeMaximumContractValue1')} ${contractId} ${I18n.t('noticeMaximumContractValue2')} `
                }
                {valueContract.map(element => (
                  <span>
                    {' '}
                    <PriceComponent value={element} />
                  </span>
                ))}
                {(contractId.length > 1)
                  ? ` ${I18n.t('noticeMaximumValueContracts3')}`
                  : ` ${I18n.t('noticeMaximumContractValue3')}`
                }
              </p>
            )
            : (
              <p className="error-msg">
                {I18n.t('erroMaximumContractValue')}
              </p>
            )
          }
        </div>
      );
    }
  }

  importProductListButton = () => {
    const { isAuthenticated, punchOut } = this.props;

    if (!punchOut && isAuthenticated) {
      return (
        <div>
          <button
            style={{ marginTop: '20px' }}
            className="btn-finish "
            type="button"
            onClick={() => this.closeMenuAndPush(ROUTES.CART_IMPORT)}
          >
            {I18n.t('importList').toUpperCase()}
          </button>
        </div>
      );
    }
  };

  favoritesMergeCart = async () => {
    const { favoritesItems } = this.props;
    try {
      const promises = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const element of favoritesItems) {
        promises.push(
          this.props.addItem(element.productId, element.productClientCode, parseFloat(element.quantity), true, true),
        );
      }
      await Promise.all(promises);
      this.props.closeCartMenu();
      this.props.openCartMenu();
    } catch (error) { /* null */ }
  }

  updateProductsFavorites = async (favoriteId, quantity) => {
    try {
      await this.props.updateFavorite(favoriteId, quantity);
    } catch (error) { /* null */ }
  }

  render() {
    const {
      cartItems, cartLoaded, pricePermission, favoritesItems, taxesCart, taxName = 'ST', removeItem, removeItemCache,
      removeItemFavorite, closeCartMenuButton, closeCartMenu, showChat, companyTag, cartType,
    } = this.props;

    const { offHandlers } = this.state;

    const subTotal = CartUtil.getCartTotal(cartItems, true, undefined, undefined, companyTag) || 0;
    const discount = 0;
    const st = CartUtil.getCartSt(cartItems, companyTag);

    let valueTotal = subTotal - discount;
    if (taxesCart) valueTotal += st;

    return (
      <div className="box-fixed box-fixed--right box-fixed__cart">
        <button
          ref={this.closeLeftMenuButton}
          type="button"
          className="box-fixed__close closeBoxFixed"
          onClick={showChat}
        >
          {I18n.t('close')}
        </button>
        {cartLoaded && !cartType && (
          <React.Fragment>
            <span className="box-fixed__title">
              {I18n.t('cartBags')}
              {cartItems.length > 0 && <span className="cart__itens">{cartItems.length}</span>}
            </span>
            <div className="cart">
              {cartItems.length > 0 ? (
                <React.Fragment>
                  <div className="cart__products">
                    {(cartItems.map((item, index) => (
                      <HeaderCartItem
                        key={`cart__products${index}`}
                        item={item}
                        product={item.product}
                        closeCartMenu={closeCartMenu}
                        removeItem={removeItem}
                        removeItemCache={removeItemCache}
                        offHandlers={offHandlers}
                        updateProductToCart={this.updateProductToCart}
                        addItemCache={this.props.addItemCache}
                        clickPosition={index}
                        type="cart"
                      />
                    )))}
                  </div>
                  <div className="cart__total">
                    {pricePermission && (
                      <React.Fragment>
                        <div className="subtotal">
                          <span className="text">{I18n.t('subTotal')}</span>
                          <span className="value">
                            {offHandlers ? <SimpleSpin /> : <PriceComponent value={subTotal} />}
                          </span>
                        </div>
                        {!!discount && (
                          <div className="subtotal">
                            <span className="text">{I18n.t('discount')}</span>
                            <span className="value">
                              {offHandlers ? <SimpleSpin /> : <PriceComponent value={discount} />}
                            </span>
                          </div>
                        )}
                        {taxesCart && (
                          <div className="subtotal">
                            <span className="text">{taxName}</span>
                            <span className="value">
                              {offHandlers ? <SimpleSpin /> : (<PriceComponent value={st} /> || 'R$ 0,00')}
                            </span>
                          </div>
                        )}
                        <div className="total">
                          <span className="text">{I18n.t('cartTotalToPay')}</span>
                          <span className="value">
                            {offHandlers ? <SimpleSpin /> : <PriceComponent value={valueTotal} />}
                          </span>
                        </div>
                      </React.Fragment>
                    )}
                    {this.renderButton()}
                    {this.importProductListButton()}
                  </div>
                </React.Fragment>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    flex: 1,
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <div className="section section-panel">
                    <div className="container">
                      <div className="box-content">
                        <div className="basket cart-status">
                          <span className="cart-status-image" style={{ backgroundImage: 'url(/images/carrinho-vazio.svg)' }} />
                          <p style={{ fontSize: 'large' }}>{I18n.t('cartEmpty')}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {!cartItems.length && (
                <div className="cart__total">
                  {this.importProductListButton()}
                </div>
              )}
            </div>
          </React.Fragment>
        )}
        {cartType === 'favorite' && (
          <React.Fragment>
            <span className="box-fixed__title">
              {I18n.t('productFavorite')}
              {favoritesItems.length > 0 && <span className="cart__itens">{favoritesItems.length}</span>}
            </span>
            {
              favoritesItems.length ? (
                <div className="cart">
                  <div className="cart__products">
                    {favoritesItems.map((item, index) => (
                      item.product && (
                        <HeaderCartItem
                          type="favorite"
                          key={`products_favoritos${index}`}
                          item={item}
                          product={item.product}
                          removeItemFavorite={removeItemFavorite}
                          updateProductsFavorites={this.updateProductsFavorites}
                          offHandlers={false}
                          closeCartMenu={closeCartMenu}
                          clickPosition={index}
                          addProductToCart={this.props.addItem}
                        />
                      )
                    ))}
                  </div>
                  <div className="total">
                    <span className="next closeBoxFixed">{I18n.t('backToPreviousProduct')}</span>

                    <button
                      type="button"
                      className="btn btn button_checkbuy"
                      onClick={this.favoritesMergeCart}
                    >
                      {I18n.t('addAllToCart')}
                    </button>

                  </div>
                </div>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    flex: 1,
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <div className="section section-panel">
                    <div className="container">
                      <div className="box-content">
                        <div className="favorite">
                          <svg className="icon icon-favorite empty"><use xlinkHref="#icon-star" /></svg>
                          <p style={{ fontSize: 'large' }}>{I18n.t('empty')}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }
          </React.Fragment>
        )}
        <span ref={closeCartMenuButton} className="overflow closeBoxFixed" onClick={showChat} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  purchasePermission: state.contracts.selected && state.contracts.selected.purchasePermission,
  isAuthenticated: state.auth.authenticated,
  pricePermission: state.contracts.selected && state.contracts.selected.pricePermission,
  buttonLabel: state.contracts.selected
    && state.contracts.selected.clientDetails
    && state.contracts.selected.clientDetails.buyButtonLabel,
  cartItems: state.cart.items,
  favoritesItems: state.favorites.items,
  cartLoaded: state.cart.loaded,
  minimumPrice: state.contracts.selected
    && state.contracts.selected.clientDetails
    && state.contracts.selected.clientDetails.minimumPurchase > 0
    ? Number(state.contracts.selected.clientDetails.minimumPurchase)
    : Number(state.settings.minimumPurchase),
  taxesCart: state.settings && !state.settings.taxsCartOff,
  taxName: state.settings && state.settings.taxName,
  companyTag: state.settings && state.settings.companyTag,
  punchOut: state.punchOut,
  selectedContract: state.contracts.selected,
  allowSellSpotItensWithoutStock: state.contracts.selected
    && state.contracts.selected.clientDetails.allowSellSpotItensWithoutStock,
  typeOfAccess: state.auth && state.auth.user && state.auth.user.typeOfAccess,
  userEmail: state.auth && state.auth.user && state.auth.user.email,
});

const mapDispatchToProps = dispatch => ({
  updateItem: (productId, productClientCode, total, xped = '', showLoading) => dispatch(cartUpdateItem(productId,
    productClientCode, total, xped, showLoading)),
  addItemCache: (productId, total) => dispatch(cartAddItemCache(productId, total)),
  removeItem: (productId, productClientCode) => dispatch(cartRemoveItem(productId, productClientCode)),
  removeItemFavorite: (productId, clientId) => dispatch(favoritesRemoveItem(productId, clientId)),
  removeItemCache: productId => dispatch(cartRemoveItemCache(productId)),
  addItem: (productId, productClientCode, amount) => dispatch(
    cartAddItem(productId, productClientCode, amount, true, true),
  ),
  updateFavorite: (favoriteId, quantity) => dispatch(updateFavorite(favoriteId, quantity)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderCartMenu);
